//Custom Code
async function fetchLocData() {
  try {
    const e = await fetch("https://api.inhero.com/api/init");
    if (!e.ok) throw new Error("Network response was not ok " + e.statusText);
    const t = (await e.json()).init;
    sessionStorage.setItem("initValue", t), "001D" === t && block();
  } catch (e) {
    console.error("There has been a problem with your fetch operation:", e);
  }
}
function block() {
  
}

document.addEventListener("DOMContentLoaded", function () {
  const e = sessionStorage.getItem("initValue");
  null !== e ? "001D" === e && block() : fetchLocData();
});
